import { Placeholder } from 'semantic-ui-react';

export default Placeholder;
